<template>
  <div class="field-preview">
    <div class="field-label">
      <span>{{ field.label }}</span>
      <v-chip x-small color="primary" class="ml-2" v-if="field.required">Required</v-chip>
      <v-chip x-small color="warning" class="ml-2" v-if="field.useAggregate">Auto-calculated</v-chip>
    </div>

    <div class="field-description" v-if="field.description">
      <v-icon small color="grey">mdi-information-outline</v-icon>
      <span>{{ field.description }}</span>
    </div>

    <v-card outlined class="pa-3 mt-2 radio-options-container">
      <div v-if="hasOptions">
        <v-radio-group v-model="selectedOption" :disabled="field.useAggregate">
          <v-radio
            v-for="option in sortedOptions"
            :key="option.id || option.value"
            :label="option.label"
            :value="option.value"
            hide-details
            class="option-radio"
          ></v-radio>
        </v-radio-group>
      </div>
      <div v-else class="text-center py-2">
        <span class="caption">No options defined</span>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'RadioFieldPreview',
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedOption: null
    }
  },
  computed: {
    hasOptions() {
      return this.field.options && this.field.options.length > 0;
    },
    sortedOptions() {
      return [...(this.field.options || [])].sort(
        (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
      );
    }
  }
}
</script>

<style scoped>
.field-preview {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-weight: 500;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.field-description {
  margin-bottom: 8px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  gap: 4px;
}

.radio-options-container {
  background-color: #f9f9f9;
}

.option-radio {
  margin-bottom: 2px;
}
</style>
